const WHAT_HAS_CHANGED_FILTER = [
  {
    title: "September 2026",
    lastUpdatedAt: "september",
    noChange: true,
    stressRate: false,
    variableIncome: false,
    hasPdf: false,
    offerExtension: false,
    links: false
  },
  {
    title: "August 2026",
    lastUpdatedAt: "august",
    noChange: false,
    stressRate: false,
    variableIncome: false,
    hasPdf: false,
    offerExtension: false,
    links: true,
    link1: "Fixed term contracts",
    link1Href: "/pdfs/Policy_Changes_Fixed_term_contacts_2026.pdf",
    link2: "Lending limits",
    link2Href: "/pdfs/Policy_Changes_Lending_limits_2026.pdf"
  }, {
    title: "July 2026",
    lastUpdatedAt: "july",
    noChange: true,
    stressRate: false,
    variableIncome: false,
    hasPdf: false,
    offerExtension: false,
    links: false
  },
];

export default WHAT_HAS_CHANGED_FILTER;

// What Has Changed utils for criteria filter
export const WHC_MONTHS = WHAT_HAS_CHANGED_FILTER.map((d) => d.title);

export const WHC_TERMS = WHAT_HAS_CHANGED_FILTER.map((d) => d.lastUpdatedAt);

export const getTermByTitle = (title) => termByTitle[title];

export const getTitleByTerm = (term) => titleByTerm[term];

let titleByTerm = Object.assign({}, ...WHAT_HAS_CHANGED_FILTER.map((item) => ({ [item.lastUpdatedAt]: item.title })));

let termByTitle = Object.assign({}, ...WHAT_HAS_CHANGED_FILTER.map((item) => ({ [item.title]: item.lastUpdatedAt })));
